<div class="form-group">

    <label [attr.for]="buildChildId()"
           [class.sr-only]="!label"
           [ngClass]="labelStyleModifier">
      {{label}}
    </label>
  
    <ng-content></ng-content>
  
    <textarea
      class="form-control"
      [attr.cols]="numberCol"
      [name]="name || label"
      [attr.maxlength]="getMaxLength()"
      [attr.disabled]="disabled ? 'disabled' : null"
      [attr.id]="buildChildId()"
      [attr.placeholder]="placeholder || null"
      [attr.aria-required]="required || null"
      [ngModel]="model"
      (ngModelChange)="onModelChange($event)"
      (keydown)="onKeyDown($event)"
      (keyup)="onKeyUp($event)"
      #entryComponent
    ></textarea>
  
  </div>


// WEBPACK FOOTER //
// ./src/app/core/achoo-material-textarea/achoo-material-textarea.component.html